<template>
  <div id="app">
    <v-app light class="white">
      <router-view/>
    </v-app>
</div>
</template>

<script>
export default {
  name: 'App',
  
  // wovn用の<head>要素をステージと本番で動的に変更する。
  metaInfo: {
    script: [{ 
        src:"//j.wovn.io/1",
        'data-wovnio': "key=" + process.env.WOVN_CODE,
        async:''
    }]
  },
  methods:{
  },
  mounted(){
  }
}

</script>

<style>
#app {
  font-family: 'Lato','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/App.vue